
import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import ArticleDetailVideo from "./ArticleDetailVideo";
import ArticleDetailImg from './ArticleDetailImg';

const styles = (theme) => ({
    root: {
        width: '100%',
    },
    layout: {
      margin: '-3px auto -3px',
    },
});

class DetailImgAndVideoItem extends React.Component{
    render(){
      const { classes, item, isServer, video, url } = this.props;
      return (
        <div className={classes.root}>
          <div className={classes.layout} >
            {
              item.type === 'IMAGE' ? 
                <ArticleDetailImg item={item} isServer={isServer} url={url} />
                :
                <ArticleDetailVideo item={item} video={video} /> 
            }
          </div>
        </div>
      );
        
    }
}

DetailImgAndVideoItem.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(DetailImgAndVideoItem);
